import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MailCheck, Loader2, AlertTriangle } from "lucide-react";
import { publicApi, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { ResendVerificationButton } from "../components/VerifyEmailBanner";
import { _t } from "@/lib/i18n";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { user, refresh } = useAuth();
  const [state, setState] = useState(token ? "loading" : "error");
  const [error, setError] = useState(token ? "" : _t("Token non valido"));
  const done = useRef(false);

  useEffect(() => {
    if (!token || done.current) return;
    done.current = true;
    publicApi.post("/auth/verify-email", { token })
      .then(() => { setState("ok"); refresh(); })
      .catch((err) => { setError(formatApiError(err)); setState("error"); });
  }, [token, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0b0d] px-4">
      <div className="tc-card p-8 md:p-10 w-full max-w-md" data-testid="verify-email-page">
        {state === "loading" && (
          <div data-testid="verify-email-loading" className="flex items-center gap-3 text-white/80">
            <Loader2 className="w-5 h-5 animate-spin" /> {_t("Verifica in corso…")}
          </div>
        )}
        {state === "ok" && (
          <div data-testid="verify-email-success">
            <MailCheck className="w-8 h-8 text-[#FF5722] mb-4" />
            <h1 className="font-display text-2xl text-white mb-3">{_t("Email confermata")}</h1>
            <p className="text-white/70">{_t("Il tuo account è attivo: ora puoi creare la tua prima capsula.")}</p>
            <Link data-testid="verify-email-continue" to={user ? "/wizard" : "/login"} className="btn-primary mt-6 inline-flex">
              {user ? _t("Crea una capsula") : _t("Accedi")}
            </Link>
          </div>
        )}
        {state === "error" && (
          <div data-testid="verify-email-error">
            <AlertTriangle className="w-8 h-8 text-amber-400 mb-4" />
            <h1 className="font-display text-2xl text-white mb-3">{_t("Link non valido")}</h1>
            <p className="text-white/70">{error}</p>
            <p className="text-white/50 mt-3 text-sm">{_t("Il link potrebbe essere scaduto o già usato. Puoi richiederne uno nuovo.")}</p>
            <div className="mt-6">
              {user ? <ResendVerificationButton email={user.email} /> :
                <Link to="/login" className="btn-primary inline-flex">{_t("Accedi")}</Link>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
